<template>
  <b-tab
    title="Cliente"
    :active="isTheCurrentTab"
    @click="() => (store.currentTab = 0)"
    :disabled="!isTheCurrentTab && !store.isUpdate"
  >
    <b-row>
      <b-col md="8">
        <b-form-group label="Cliente" label-for="nome">
          <CadastroRapidoSelect
            ref="buscarCliente"
            :state="validateClienteState('nome')"
            entity-label="cliente"
            :min-create-length="3"
            :creating="criandoCliente"
            :value="form"
            @input="setCliente"
            @create="criarClienteInline"
            :class="{ hasErrors: clienteError, inputFilled: clienteFilled }"
            :options="clientes"
            @search="onSearchCliente"
          >
            <template slot="no-options"> Informe o nome do cliente </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>{{ option.codigo }} - {{ option.nome }}</div>
                <span class="text-muted"
                  >CPF: {{ formatCpfCnpj(option.cnpj_cpf) }}</span
                >
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.nome }}
              </div>
            </template>
          </CadastroRapidoSelect>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="CPF/CNPJ" label-for="cnpj_cpf">
          <b-form-input
            v-if="hasCnpjAlfanumerico(form.cnpj_cpf)"
            :key="`${keyToReRender}-alfa`"
            disabled
            id="cnpj_cpf"
            name="cnpj_cpf"
            :value="formatCnpjAlfanumerico(form.cnpj_cpf)"
          >
          </b-form-input>
          <b-form-input
            v-else
            :key="`${keyToReRender}-numeric`"
            disabled
            id="cnpj_cpf"
            name="cnpj_cpf"
            v-mask="['###.###.###-##', '###.###.###/####-##']"
            v-model="form.cnpj_cpf"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="10" v-if="form?.enderecos">
        <b-form-group
          :key="keyToReRender"
          label="Endereço"
          label-for="endereco"
        >
          <b-form-input
            disabled
            id="endereco"
            name="endereco"
            :value="formatEndereco(form?.enderecos[0])"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-form-group label="Solicitante" label-for="solicitante">
          <b-form-input
            id="solicitante"
            name="solicitante"
            v-model="form.solicitante"
            maxlength="50"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="Vendedor" label-for="vendedor">
          <CadastroRapidoSelect
            ref="buscaVendedor"
            entity-label="vendedor"
            :creating="criandoVendedor"
            :value="vendedor"
            @input="setVendedor"
            @create="criarVendedorInline"
            :options="vendedores"
            @search="onSearchVendedor"
          >
            <template slot="no-options"> Informe o nome do vendedor </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.nome }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.nome }}
              </div>
            </template>
          </CadastroRapidoSelect>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <button
          ref="add_buyer"
          class="btn btn-primary font-weight-bold"
          v-b-modal.newClient
          style="font-size: 11px; margin-top: 30px"
        >
          Cadastro completo
        </button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4" style="margin-top: 20px" v-if="form.tipo_atacado">
        <span class="label label-lg label-inline label-light-warning"
          >Tipo Atacado</span
        >
      </b-col>
      <b-col sm="4" v-if="listaPreco">
        <p class="text-muted">
          Lista de preço aplicada:
          <span class="font-weight-bold text-primary">{{
            listaPreco.descricao
          }}</span>
        </p>
      </b-col>
    </b-row>

    <NovoClienteModal
      modal-id="newClient"
      @selected="handleNovoClienteSelected"
    />
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { ClienteDataRequired } from "../ClienteData";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeOrcamento";
import NovoClienteModal from "@/modules/Pessoa/components/NovoClienteModal.vue";
import CadastroRapidoSelect from "@/components/CadastroRapidoSelect.vue";
import CadastroRapidoMixin from "@/modules/Application/mixins/CadastroRapidoMixin";

export default {
  name: "app-orcamento-form-clienteTab",
  components: {
    CadastroRapidoSelect,
    NovoClienteModal,
  },
  directives: {
    mask,
  },
  data() {
    return {
      form: {
        nome: null,
        cnpj_cpf: null,
      },
      listaPreco: null,
      clientes: [],
      cliente: null,
      keyToReRender: 0,
      store,
      clienteError: false,
      enderecoError: false,
      clienteFilled: false,
      vendedores: [],
      vendedor: null,
      criandoCliente: false,
      criandoVendedor: false,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, CadastroRapidoMixin],
  validations: {
    form: ClienteDataRequired,
  },
  methods: {
    ...mapActions(["setLoading"]),
    handleLoading(value) {
      this.setLoading(value);
    },
    validateClienteState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSearchCliente(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getClientes(search);
      loading(false);
    }, 350),
    setCliente(cliente) {
      if (!cliente) {
        this.form = {
          nome: null,
          cnpj_cpf: null,
        };
        this.clienteFilled = false;
        this.listaPreco = null;
        return;
      }
      if (this.bloquearClienteInadimplenteSelecionado(cliente)) {
        this.form = {
          nome: null,
          cnpj_cpf: null,
        };
        this.clienteFilled = false;
        return;
      }

      if (this.vendedorLogado?.id_vendedor) {
        if (!this.$route.params.orcamentoData?.vendedor) {
          this.vendedor = this.vendedorLogado;
          this.store.formCliente.vendedor = this.vendedorLogado.id_vendedor;
        }
      }

      this.form = cliente;
      this.clienteFilled = true;
      this.listaPreco = null;

      if (cliente?.lista_preco) {
        this.listaPreco = cliente.lista_preco;
      }

      if (Object.keys(this.$route.params).length !== 0) {
        this.form.solicitante = this.$route.params.orcamentoData.solicitante;
      }
    },
    formatEndereco(endereco) {
      if (!endereco) return "";
      const formatData = `${endereco.cep ?? ""}, ${
        endereco.logradouro ?? ""
      }, ${endereco.numero ?? ""}, ${endereco.bairro ?? ""} - ${
        endereco?.cidade?.cidade ?? ""
      } / ${endereco?.cidade?.uf ?? ""}`;
      return formatData;
    },
    setVendedor(vendedor) {
      this.vendedor = vendedor || null;
      this.store.formCliente.vendedor = vendedor?.id_vendedor ?? null;
    },
    onSearchVendedor(search, loading) {
      if (search.length) {
        loading(true);
        this.searchVendedor(loading, search, this);
      }
    },
    searchVendedor: _.debounce(async (loading, search, vm) => {
      vm.vendedores = await vm.getVendedorByNome(search);
      if (loading) loading(false);
    }, 350),
    handleNovoClienteSelected(cliente) {
      this.setCliente(cliente);
    },
    async criarClienteInline(nome) {
      if (this.criandoCliente) return;

      this.criandoCliente = true;
      try {
        const cliente = await this.criarClienteCadastroRapido(nome);
        this.clientes = [
          cliente,
          ...this.clientes.filter(
            (item) => item.id_pessoa !== cliente.id_pessoa
          ),
        ];
        this.setCliente(cliente);
        this.$toast.success("Cliente criado e selecionado!");
      } catch (error) {
        this.$toast.error(
          this.mensagemErroCadastroRapido(
            error,
            "Não foi possível criar o cliente."
          )
        );
      } finally {
        this.criandoCliente = false;
      }
    },
    async criarVendedorInline(nome) {
      if (this.criandoVendedor) return;

      this.criandoVendedor = true;
      try {
        const vendedor = await this.criarVendedorCadastroRapido(nome);
        this.vendedores = [
          vendedor,
          ...this.vendedores.filter(
            (item) => item.id_vendedor !== vendedor.id_vendedor
          ),
        ];
        this.setVendedor(vendedor);
        this.$toast.success("Vendedor criado e selecionado!");
      } catch (error) {
        this.$toast.error(
          this.mensagemErroCadastroRapido(
            error,
            "Não foi possível criar o vendedor."
          )
        );
      } finally {
        this.criandoVendedor = false;
      }
    },
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      this.handleLoading(true);
      const id_pessoa = this.$route.params.orcamentoData.cliente.id_pessoa;
      this.vendedor = this.$route.params.orcamentoData?.vendedor;

      if (!this.vendedor) {
        if (this.vendedorLogado?.id_vendedor) {
          this.vendedor = this.vendedorLogado;
          this.store.formCliente.vendedor = this.vendedorLogado.id_vendedor;
        }
      }

      this.$http
        .post("/pessoa/find", {
          id_pessoa,
        })
        .then((response) => {
          this.setCliente(response.data);
        })
        .catch((error) =>
          this.$toast.error(`Erro ao buscar cliente:\n${error}`)
        );
      this.handleLoading(false);
    } else {
      this.vendedor = null;

      if (this.vendedorLogado?.id_vendedor) {
        this.vendedor = this.vendedorLogado;
        this.store.formCliente.vendedor = this.vendedorLogado.id_vendedor;
      }
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    ...mapState({
      vendedorLogado: (state) => state.auth.vendedor,
    }),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 0;
    },
  },
  watch: {
    "store.formCliente"(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.keyToReRender++;
      }
    },
    form(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;
      this.store.formCliente = newValue;
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 1 && oldValue < newValue) {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          if (this.$v.form.$anyError) {
            this.store.currentTab = oldValue;
            if (this.$v.form.nome.$anyError) {
              this.$toast.error("Informe o cliente!");
              this.clienteError = true;
            }
          }
          return;
        }
      }
    },
  },
};
</script>
